module.exports = __webpack_public_path__ + "media/images/emblems/Turbenthal-a3692a52e41a886c9c95fbc68fc4222b.svg";